<template>
  <div >
    <div class="rec">
      <el-button type='primary' @click='getRecommendCode'>实时获取注册码</el-button>
      <div>
        <p>{{ recommendCode }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      // 注册码
      recommendCode: ''
    }
  },
  created () {
  },
  watch: {
  },
  methods: {
    async getRecommendCode () {
      const { data: res } = await this.$http.get('/mobile/getRecommendCode')
      if (res.code !== 1) {
        return this.$message.error('获取注册码失败！')
      }
      console.info(this.res)
      this.recommendCode = res.body
      console.info('======================recommendCode')
      console.info(this.recommendCode)
    }
  }
}
</script>

<style scoped>
.rec {
  width: 15%;
  height: 100%;
  float: left;
  margin-top: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/recommend.vue